export const authCookieOptions = (overrides: Record<string, unknown> = {}) => ({
  path: '/',
  secure: window.location.protocol === 'https:',
  sameSite: 'lax' as const,
  ...overrides,
});
